exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-remove-from-cart-dialog .fi-dialog-content {\n  min-width: 450px;\n  margin-top: 20px;\n  margin-bottom: 15px;\n}", ""]);

// exports
